import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import vuetify from './plugins/vuetify'
import './firebase'
import store from './store'

console.log(vuetify.icons);

const app = createApp(App);
app.use(store).use(router).use(vuetify).mount('#app');



